import { RootState } from '@src/redux/interfaces/redux.interface';

export const getRecruiter = ({ recruiter }: RootState): RootState['recruiter'] => recruiter;
export const getCustomerStatus = ({ customerStatus }: RootState): RootState['customerStatus'] => customerStatus;
